import { ProfileReference } from "@rentablo/api/apiv1";

export const getLetters = (data?: { profileReference: ProfileReference }) => {
  const firstName = data?.profileReference?.firstName;
  const lastName = data?.profileReference?.lastName;
  if (firstName && lastName)
    return [
      data.profileReference.firstName![0],
      data.profileReference.lastName![0],
    ];
  return ["N", "A"];
};
